
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/wixData/components/emptyState.scss.css.virtualfile';
        module.exports = {"actionsContainer":"_actionsContainer_1bgt0_7","settingsIcon":"_settingsIcon_1bgt0_14"};